import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, catchError, switchMap, take, map } from 'rxjs';
import { UserSettingsService } from '../../user-settings/services/user-settings.service';
import { HomepageManagerService } from '../homepage/services/homepage-manager.service';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { MojoUrlProvider } from '@mojo/services/mojo-url-provider';

/**
 * If the user is in dashboard mode, then this guard will cancel current navigation and navigate to the users selected homepage
 * Otherwise it will allow routing to continue
 **/
@Injectable()
export class DashboardHomePageRouteGuard  {

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    return this.userSettings.getUserSettings()
      .pipe(
        map((userSettings) => userSettings.IsInMyDashboardMode),
        filter(isInDashboardMode => isInDashboardMode != undefined),
        switchMap(isInDashboardMode => {
          if (!isInDashboardMode) {
            return of(true);
          } else {
            return this.homepageManagerService.getHomepage()
              .pipe(
                take(1),
                map(url => {
                  if (url == undefined) {
                    this.router.navigate(['/externalRedirect', { externalUrl: this.mojoUrls.myActivities()}]);
                    return false;
                  }
                  // what if url is internal?
                  this.router.navigate(['/externalRedirect', { externalUrl: url }]);
                  return false;
                })
              );
          }
        })
      );
  }

  constructor(
    private readonly router: Router,
    private readonly homepageManagerService: HomepageManagerService,
    private readonly userSettings: UserSettingsService,
    private readonly mojoUrls: MojoUrlProvider
  ) { }

}
